import { useState, useEffect } from "react";
import {
  Grid,
  Autocomplete,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import CustomTableNew from "../components/CustomTableNew.jsx";
import axios from "../customAxios.js";
import LoadingComponent from "../components/LoadingComponent.jsx";

function WarehouseInventory() {
  //values to control pagination of the component table
  const [page, setPage] = useState(
    localStorage.getItem("invenotryWarehouseFilter")
      ? JSON.parse(localStorage.getItem("invenotryWarehouseFilter")).page
      : 0
  );
  const [rowsPerPage, setRowsPerPage] = useState(
    localStorage.getItem("invenotryWarehouseFilter")
      ? JSON.parse(localStorage.getItem("invenotryWarehouseFilter")).rowsPerPage
      : 20
  );

  //data that will be set on every page change and filter set
  const [pageData, setPageData] = useState();
  const [loadingPageData, setLoadingPageData] = useState(true);

  //filter values of the table
  const [search, setSearch] = useState(
    localStorage.getItem("invenotryWarehouseFilter")
      ? JSON.parse(localStorage.getItem("invenotryWarehouseFilter")).search
      : ""
  );
  const [slotFilter, setSlotFilter] = useState(
    localStorage.getItem("invenotryWarehouseFilter")
      ? JSON.parse(localStorage.getItem("invenotryWarehouseFilter")).slotFilter
      : { id: "all", name: "Todas" }
  );

  //aux values for delay on text search fields
  const [auxSearcher, setAuxSearcher] = useState(
    localStorage.getItem("invenotryWarehouseFilter")
      ? JSON.parse(localStorage.getItem("invenotryWarehouseFilter")).search
      : ""
  );

  //useState to count the total number of assignments filtered by backend
  const [assignmentsCount, setAssignmentsCount] = useState(0);

  const [slots, setSlots] = useState([]);
  const [error, setError] = useState(false);
  const [newSlot, setNewSlot] = useState(null);

  //use state not related to pagination or filters
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [messageAlert, setMessageAlert] = useState("");
  const [openMoveDialog, setOpenMoveDialog] = useState(false);
  const [selectedAssignment, setSelectedAssignment] = useState(null);
  const [stockToMove, setStockToMove] = useState(1);
  const [slotToMove, setSlotToMove] = useState(null);
  const [submitMoveAssignment, setSubmitMoveAssignment] = useState(false);
  const [invalidStockToMove, setInvalidStockToMove] = useState(false);
  const [invalidSlotToMoveAlert, setInvalidSlotToMoveAlert] = useState("");
  const [uploadFileType, setUploadFileType] = useState(null);

  //useState to catch when general data is already fetched
  const [generalParamsFetched, setGeneralParamsFetched] = useState(false);

  //File upload options
  const file_options = [
    { label: "Cargar Stock", value: "stocks" },
    { label: "Cargar Nuevos Productos", value: "products" },
  ];

  //initial render flag for pagination settings
  const [isInitialRender, setIsInitialRender] = useState(true);

  const searchParams = () => {
    return {
      slot: slotFilter,
      search: search,
    };
  };

  //function to fetch all general parameters that do not depends on the page and rowsPerPage
  async function fetchGeneralParams() {
    try {
      const { data } = await axios.get(
        "products/warehouse_assignments/general_params/",
        { params: searchParams() }
      );
      setAssignmentsCount(data.number_of_assignments);
      setGeneralParamsFetched(true);
    } catch (error) {
      console.error(`error: ${error}`);
    }
  }

  useEffect(() => {
    fetchGeneralParams();
  }, [slotFilter, search]);

  //set page to 0 when necessary
  useEffect(() => {
    //if localStorage "invenotryWarehouseFilter" does not exist, set page to 0
    if (!localStorage.getItem("invenotryWarehouseFilter")) {
      setPage(0);
    }
    //if is on useEffect not on initial render, set page 0
    if (isInitialRender) {
      setIsInitialRender(false);
    } else {
      setPage(0);
    }
  }, [slotFilter, search, rowsPerPage]);

  //load page data on changes
  useEffect(() => {
    if (!loadingPageData) {
      setLoadingPageData(true);
    }
    fetchAssignments();
    //save on localStorage the filter and page values of orders
    localStorage.setItem(
      "invenotryWarehouseFilter",
      JSON.stringify({ slotFilter, search, page, rowsPerPage })
    );
  }, [slotFilter, search, rowsPerPage, page]);

  //useEffect to catch auxSearcher changes, and triger a function every 2 seconds that dont change
  useEffect(() => {
    // Delayed search function
    const delayedSearch = (value) => {
      // Your search logic goes here
      setSearch(value);
    };
    if (!loadingPageData) {
      setLoadingPageData(true);
    }
    // Timer variable for setTimeout
    let timer;

    // Set a delay of 2 seconds before executing the search
    const delay = 1500;

    // Clear the previous timer when auxSearcher changes
    clearTimeout(timer);

    // Set a new timer for delayed search
    timer = setTimeout(() => {
      delayedSearch(auxSearcher);
    }, delay);

    // Clean up the timer on component unmount or when auxSearcher changes
    return () => {
      clearTimeout(timer);
    };
  }, [auxSearcher]);

  const fetchAssignments = async () => {
    const search_params_fetch_assignements = {
      slot: slotFilter,
      search: search,
      page: page,
      rowsPerPage: rowsPerPage,
    };
    setLoadingPageData(true);
    try {
      const {
        data: { assignments },
      } = await axios.get("products/warehouse_assignments/", {
        params: search_params_fetch_assignements,
      });
      setPageData(assignments);
    } catch (error) {
      setPageData([]);
      console.error("Error al cargar los productos", error);
    } finally {
      setLoadingPageData(false);
    }
  };

  const fetchSlots = async () => {
    setError(false);
    try {
      const {
        data: { slots },
      } = await axios.get("slots/warehouse_slots/");
      setSlots(slots);
      console.info("Se han cargado las ubicaciones correctamente");
    } catch (error) {
      setError(true);
      console.error(`Error al cargar las ubicaciones: ${error}`);
    }
  };

  const handleAddSlot = async () => {
    if (newSlot === null || newSlot === "") {
      setOpenErrorAlert(true);
      setMessageAlert("Debe ingresar un nombre para la ubicación");
      return;
    } else if (slots.some((slot) => slot.name === newSlot)) {
      setOpenErrorAlert(true);
      setMessageAlert("Ya existe una ubicación con ese nombre");
      return;
    } else {
      console.log("nueva ubicación: ", newSlot);
      try {
        await axios.post("slots/create_slot/", { name: newSlot });
        fetchSlots();
        setNewSlot("");
        setOpenSuccessAlert(true);
        setMessageAlert("Se ha creado la ubicación correctamente");
      } catch (error) {
        console.error(`Error al crear la ubicación ${error}`);
        setOpenErrorAlert(true);
        setMessageAlert("Error al crear la ubicación");
      }
    }
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
    setOpenErrorAlert(false);
  };

  const showAlert = (message, success) => {
    setMessageAlert(message);
    if (success) {
      setOpenSuccessAlert(true);
    } else {
      setOpenErrorAlert(true);
    }
  };

  const handleMoveAssignment = (assignment) => {
    setSelectedAssignment(assignment);
    setOpenMoveDialog(true);
  };

  const handleCloseMoveDialog = () => {
    setOpenMoveDialog(false);
    setStockToMove(1);
    setSlotToMove(null);
    setInvalidSlotToMoveAlert("");
    setInvalidStockToMove(false);
  };

  const handleSubmitMoveAssignment = async () => {
    setSubmitMoveAssignment(true);
    setInvalidSlotToMoveAlert("");
    setInvalidStockToMove(false);
    let invalid = false;
    if (slotToMove === null) {
      setInvalidSlotToMoveAlert("Debe seleccionar una ubicación");
      invalid = true;
    } else if (slotToMove.name === selectedAssignment.slot.name) {
      setInvalidSlotToMoveAlert(
        "Debe seleccionar una ubicación diferente a la actual"
      );
      invalid = true;
    }
    if (stockToMove > selectedAssignment.stock || stockToMove < 1) {
      setInvalidStockToMove(true);
      invalid = true;
    }
    if (invalid) return;
    try {
      await axios.put("products/update_assignment/", {
        assignment_id: selectedAssignment.id,
        slot_id: slotToMove.id,
        stock: stockToMove,
      });
      showAlert(
        "Se ha actualizado correctamente la ubicación del producto",
        true
      );
    } catch (error) {
      console.error(`Error al actualizar la ubicación del producto ${error}`);
      showAlert("Error al actualizar la ubicación del producto", false);
    } finally {
      fetchAssignments();
      handleCloseMoveDialog();
    }
  };

  const uploadInventoryExcel = async (event) => {
    const selectedFile = event.target.files[0];
    var formData = new FormData();
    formData.append("excel_file", selectedFile);
    try {
      await axios.post("warehouses/upload_excel_inventory/", formData);
      fetchAssignments();
      showAlert("Se ha cargado el archivo correctamente", true);
    } catch (error) {
      console.error(`Error al cargar el archivo: ${error}`);

      let errorMessage = "Error al cargar el archivo";
      if (
        error?.response &&
        error?.response?.data &&
        error?.response?.data?.error
      ) {
        errorMessage += ": " + error.response.data.error;
      }
      showAlert(errorMessage, false);
    }
  };

  const uploadProductsExcel = async (event) => {
    const selectedFile = event.target.files[0];
    var formData = new FormData();
    formData.append("excel_file", selectedFile);
    try {
      await axios.post("products/upload_excel_products/", formData);
      showAlert("Se ha cargado el archivo correctamente", true);
    } catch (error) {
      console.error(`Error al cargar el archivo: ${error}`);

      let errorMessage = "Error al cargar el archivo";
      if (
        error?.response &&
        error?.response?.data &&
        error?.response?.data?.error
      ) {
        errorMessage += ": " + error.response.data.error;
      }
      showAlert(errorMessage, false);
    }
  };

  useEffect(() => {
    fetchAssignments();
    fetchSlots();
  }, []);

  // Function to open file selector for stocks
  const openFileSelector = (type) => {
    const inputElement = document.createElement("input");
    inputElement.type = "file";
    inputElement.accept = ".xlsx";
    if (type === "stocks") {
      inputElement.onchange = uploadInventoryExcel;
    } else if (type === "products") {
      inputElement.onchange = uploadProductsExcel;
    }
    inputElement.click();
  };

  //useEffect to open file selector while selecting file type
  useEffect(() => {
    if (uploadFileType) {
      if (uploadFileType.value === "stocks") {
        openFileSelector("stocks");
      } else if (uploadFileType.value === "products") {
        openFileSelector("products");
      }
      setUploadFileType(null);
    }
  }, [uploadFileType]);

  const headerTable = [
    { columnName: "Seller", dbName: "seller", enabled: true },
    { columnName: "SKU", dbName: "sku", enabled: true },
    { columnName: "Código de barras", dbName: "bar_code", enabled: true },
    { columnName: "Producto", dbName: "name", enabled: true },
    { columnName: "Precio", dbName: "price", enabled: true },
    { columnName: "Stock", dbName: "stock", enabled: true },
    { columnName: "Ubicación", dbName: "location", enabled: true },
    { columnName: "Mover", dbName: "move", enabled: true },
  ];

  if (generalParamsFetched) {
    return (
      <>
        <Grid item xs={12}>
          <h1>Inventario</h1>
        </Grid>

        <Grid item xs={12} sm className="filters-container">
          <div className="row-container">
            <Grid item xs={6} sm="auto" className="input-service-filter">
              <TextField
                variant="outlined"
                label="Buscar"
                name="search"
                value={auxSearcher}
                onChange={(e) => {
                  setAuxSearcher(e.target.value);
                }}
                className="mg-l-10"
              />
            </Grid>

            <Grid item xs={6} sm="auto">
              <Autocomplete
                fullWidth
                id="location-select"
                options={[{ id: "all", name: "Todas" }, ...slots]}
                getOptionLabel={(slot) => (slot ? slot.name : "")}
                renderInput={(params) => (
                  <TextField {...params} label="Buscar Ubicación" />
                )}
                value={slotFilter}
                onChange={(event, newValue) =>
                  setSlotFilter(
                    newValue ? newValue : { id: "all", name: "Todas" }
                  )
                }
              />
            </Grid>
            <Grid item xs={6} sm="auto" className="input-service-filter">
              <Autocomplete
                fullWidth
                id="location-select"
                options={file_options}
                getOptionLabel={(option) => (option ? option.label : "")}
                renderInput={(params) => (
                  <TextField {...params} label="Cargar archivo" />
                )}
                value={uploadFileType}
                onChange={(event, newValue) => setUploadFileType(newValue)}
              />
            </Grid>
          </div>
          <div className="row-container">
            <Grid item xs={6} sm="auto">
              <TextField
                variant="outlined"
                label="Nueva ubicación"
                name="search"
                value={newSlot}
                onChange={(e) => {
                  setNewSlot(e.target.value);
                }}
                className="mg-l-10"
              />
            </Grid>
            <Grid item xs={6} sm="auto" className="input-service-filter">
              <Button
                variant="outlined"
                component="label"
                color="secondary"
                className="mg-l-10"
                onClick={() => {
                  handleAddSlot();
                }}
              >
                Agregar Ubicación
              </Button>
            </Grid>
          </div>
        </Grid>
        <br />
        <Grid container className="custom-table-container">
          <Grid item xs={12} className="flex-center mg-t-0">
            <CustomTableNew
              searchParams={searchParams}
              search={search}
              headerTable={headerTable}
              selected={"none"}
              setSelected={"none"}
              openCollapseButton={true}
              openCollapseTooltip={"Ver más"}
              openCollapseIcon={
                <i className="material-icons-outlined icon-actions-panel-test">
                  add_circle_outline
                </i>
              }
              collapseType={"products-inventory"}
              hasPagination={true}
              slots={slots}
              editable={true}
              filterStates={{ slotFilter, search }}
              totalCount={assignmentsCount}
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              pageData={pageData}
              setPageData={setPageData}
              loadingPageData={loadingPageData}
              handleMoveAssignment={handleMoveAssignment}
            />
          </Grid>
        </Grid>
        <Snackbar
          open={openSuccessAlert}
          autoHideDuration={6000}
          onClose={handleCloseAlert}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert severity="success" sx={{ width: "100%" }}>
            {messageAlert}
          </Alert>
        </Snackbar>
        <Snackbar
          open={openErrorAlert}
          autoHideDuration={6000}
          onClose={handleCloseAlert}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert severity="error" sx={{ width: "100%" }}>
            {messageAlert}
          </Alert>
        </Snackbar>

        <Dialog open={openMoveDialog} onClose={() => handleCloseMoveDialog()}>
          <DialogTitle>Mover existencias</DialogTitle>
          <DialogContent>
            <form noValidate autoComplete="off">
              <TextField
                fullWidth
                label={`Stock a Mover (Max. ${
                  selectedAssignment ? selectedAssignment.stock : ""
                })`}
                type="number"
                value={stockToMove}
                onChange={(e) => setStockToMove(e.target.value)}
                inputProps={{
                  min: 1,
                  max: selectedAssignment ? selectedAssignment.stock : 1,
                  step: 1,
                  placeholder: `Límite: ${
                    selectedAssignment ? selectedAssignment.stock : 1
                  }`,
                }}
                helperText={
                  submitMoveAssignment &&
                  invalidStockToMove &&
                  "Debe ingresar un número entre 1 y " +
                    selectedAssignment.stock
                }
                error={submitMoveAssignment && invalidStockToMove}
                style={{ width: "270px" }}
              />
              <Autocomplete
                fullWidth
                id="order-type-select"
                options={slots}
                getOptionLabel={(slot) => (slot ? slot.name : "")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Nueva ubicación (Actual: ${
                      selectedAssignment ? selectedAssignment.slot.name : ""
                    })`}
                    helperText={
                      submitMoveAssignment &&
                      invalidSlotToMoveAlert !== "" &&
                      invalidSlotToMoveAlert
                    }
                    error={
                      submitMoveAssignment && invalidSlotToMoveAlert !== ""
                    }
                  />
                )}
                value={slotToMove}
                onChange={(event, newValue) => setSlotToMove(newValue)}
                style={{ width: "270px" }}
              />
              <Button
                variant="contained"
                color="primary"
                style={{ marginTop: "10px" }}
                onClick={handleSubmitMoveAssignment}
              >
                Mover
              </Button>
            </form>
          </DialogContent>
        </Dialog>
      </>
    );
  } else {
    return <LoadingComponent />;
  }
}

export default WarehouseInventory;
